module.exports = __webpack_public_path__ + "static/media/chip_50.0a1d5608.png";